import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { type SellerPromotionV2 } from '@redteclab/api/clients/bully'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { getFormattedPromotionDiscountedAmountOrPercentage } from '../../../../models'

import { DynamicProductSellerVoucherLabelDiscountDialogContent } from './DynamicProductSellerVoucherLabelDiscountDialogContent'
import { useProductSellerVoucherLabelDiscountDialogContext } from './ProductSellerVoucherLabelDiscountDialogContext'

type ProductSellerVoucherLabelDiscountDialogProps = {
  isOpen: boolean
  onClose: () => void
  sellerPromotion: SellerPromotionV2
  showLinkToPromotionPage?: boolean
  showRecommendations?: boolean
  termsExpanded?: boolean
}

export const ProductSellerVoucherLabelDiscountDialog: FC<
  ProductSellerVoucherLabelDiscountDialogProps
> = ({
  isOpen,
  onClose,
  sellerPromotion,
  showLinkToPromotionPage,
  showRecommendations,
  termsExpanded,
}) => {
  const intl = useIntl()
  const dialogContext = useProductSellerVoucherLabelDiscountDialogContext()

  return (
    <Dialog
      data-qa-id="product-voucher-explainer"
      onClose={onClose}
      open={isOpen}
    >
      <DialogTitle onClose={onClose}>
        <FormattedMessage
          id="seller.promotion.product.discount.withCode"
          values={{
            discountPercent: getFormattedPromotionDiscountedAmountOrPercentage(
              sellerPromotion,
              intl,
            ),
          }}
        />
      </DialogTitle>
      <DialogContent>
        <DynamicProductSellerVoucherLabelDiscountDialogContent
          sellerPromotion={sellerPromotion}
          showLinkToPromotionPage={
            showLinkToPromotionPage ?? dialogContext.showLinkToPromotionPage
          }
          showRecommendations={
            showRecommendations ?? dialogContext.showRecommendations
          }
          termsExpanded={termsExpanded ?? dialogContext.termsExpanded}
        />
      </DialogContent>
    </Dialog>
  )
}
